import { api } from './';

import { IReportInput } from 'src/interfaces/report';

const ReportService = {
  current: async ({ reportType, cellId, date }: IReportInput) => {
    const res = await api.get(`/reports/productions`, {
      params: { reportType, cellId, date },
    });

    return res.data;
  },

  byOperationGroup: async ({ cellId, date }: { cellId?: string; date: string }) => {
    const res = await api.get(`/reports/productions/by-operation-group`, {
      params: { cellId, date },
    });

    return res.data;
  },

  efficiency: async ({ cellId, date }: { cellId?: string; date: string }) => {
    const res = await api.get(`/productions/reports/operators-efficiency`, {
      params: { cellId, date },
    });

    return res.data;
  },
};

export default ReportService;
